module.exports = __webpack_public_path__ + "img/logo_pera.bb43f663.svg";